<template>
  <div>
    <toolbar />
    <div class="containerFull">
      <headerbar />
      <br />
      <form @submit.prevent="submitForm">
        <div>
          <div class="content-step content-first-step">
            <div class="form-group col-md-12">
              <h4>Primeira tela do formulário</h4>
              <label for="head-text-step1">Texto do Cabeçalho:</label>
              <vue-editor
                v-model="formContent.textFirstView"
                class="editor"
                id="head-text-step1"
                :editor-toolbar="customBaseToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="!formContent.textFirstView.replace(/<[^>]+>/g, '').trim()"
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
            </div>
            <div class="form-group col-md-12">
              <h4>Texto do balão de aviso</h4>
              <label for="balao-aviso">Texto</label>
              <textarea
                v-model="formContent.textWarningBalloon"
                id="balao-aviso"
                class="form-control"
                rows="4"
              ></textarea>
              <p
                class="warning"
                v-if="
                  !formContent.textWarningBalloon.replace(/<[^>]+>/g, '').trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
            </div>
            <button
              :disabled="isButtonDisabled"
              class="btn btn-primary"
              type="submit"
            >
              Salvar Alterações
            </button>
          </div>
          <div class="content-step content-first-step">
            <div class="form-group col-md-12">
              <h4>Segunda tela do formulário</h4>
              <label for="head-text-step2">Texto Cabeçalho:</label>
              <vue-editor
                v-model="formContent.textSecondView"
                id="head-text-step2"
                :editor-toolbar="customBaseToolbar"
              ></vue-editor>
              <p
                class="warning"
                v-if="
                  !formContent.textSecondView.replace(/<[^>]+>/g, '').trim()
                "
              >
                Este campo é obrigatório, não pode estar vazio.
              </p>
            </div>
            <button
              :disabled="isButtonDisabled"
              class="btn btn-primary"
              type="submit"
            >
              Salvar Alterações
            </button>
          </div>
          <div class="content-step content-first-step">
            <div class="form-group col-md-12">
              <div class="form-group col-md-12">
                <h4>Tela de Orçamento</h4>
                <p class="warning-format">
                  [username] e [amount] são termos variáveis, que serão
                  substituídos pelos dados correspondentes na tela do orçamento.
                  O username pelo o nome de usuário da pessoa que está
                  solicitando o orçamento e o amount pela quantidade orçada.
                  Para usar o ícone do WhatsApp basta inserir o termo,
                  [whatsAppIcon]. O mesmo será substituido pelo ícone. <br />
                  <span class="important"
                    >Devem estar sempre dentro de colchetes para o efeito
                    correto. desta forma: [username], [amount] e [whatsAppIcon]
                  </span>
                </p>
                <label for="text-result-default"
                  >Texto padrão página de resultado</label
                >
                <vue-editor
                  v-model="formContent.textForNonCustom"
                  id="text-result-default"
                  :editor-toolbar="customToolbar"
                ></vue-editor>

                <p
                  class="warning"
                  v-if="
                    !formContent.textForNonCustom.replace(/<[^>]+>/g, '').trim()
                  "
                >
                  Este campo é obrigatório, não pode estar vazio.
                </p>
                <label for="text-result-default"
                  >Texto personalizado página de resultado</label
                >
                <vue-editor
                  v-model="formContent.textForCustom"
                  id="text-result"
                  :editor-toolbar="customToolbar"
                ></vue-editor>
                <p
                  class="warning"
                  v-if="
                    !formContent.textForCustom.replace(/<[^>]+>/g, '').trim()
                  "
                >
                  Este campo é obrigatório, não pode estar vazio.
                </p>
                <label for="text-result-default"
                  >Texto para orçamento não encontrado página de
                  resultado</label
                >
                <vue-editor
                  v-model="formContent.textForNotFound"
                  id="text-result"
                  :editor-toolbar="customToolbar"
                ></vue-editor>
                <p
                  class="warning"
                  v-if="
                    !formContent.textForNotFound.replace(/<[^>]+>/g, '').trim()
                  "
                >
                  Este campo é obrigatório, não pode estar vazio.
                </p>
              </div>

              <div>
                <label for="link-whatsapp">Link do WhatsApp:</label>
                <textarea
                  v-model="formContent.textLinkWhatsapp"
                  id="link-whatsapp"
                  class="form-control"
                  rows="3"
                ></textarea>
                <p
                  class="warning"
                  v-if="
                    !formContent.textLinkWhatsapp.replace(/<[^>]+>/g, '').trim()
                  "
                >
                  Este campo é obrigatório, não pode estar vazio.
                </p>
              </div>

              <div>
                <label for="link-files">Link para envio de arquvivos:</label>
                <textarea
                  v-model="formContent.textlinkSendFiles"
                  id="link-files"
                  class="form-control"
                  rows="3"
                ></textarea>
                <p
                  class="warning"
                  v-if="
                    !formContent.textlinkSendFiles
                      .replace(/<[^>]+>/g, '')
                      .trim()
                  "
                >
                  Este campo é obrigatório, não pode estar vazio.
                </p>
              </div>
            </div>
            <button
              :disabled="isButtonDisabled"
              class="btn btn-primary"
              type="submit"
            >
              Salvar Alterações
            </button>
          </div>
        </div>
      </form>
      <br />
    </div>
  </div>
</template>

<script>
import Headerbar from "@/components/Nav/Headerbar";
import Toolbar from "@/components/Nav/Toolbar";
import { VueEditor } from "vue2-editor";
import { removeEmptySpaces } from "../../Utils/removeEmptySpaces";

export default {
  name: "dashboard-edit-form",
  props: {},
  data() {
    return {
      customBaseToolbar: [
        ["bold", "italic", "underline"],
        [{ header: [1, 2, 3, false] }],
      ],
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        [{ size: ["small", false, "large", "huge"] }],
        ["link"],
      ],
    };
  },

  async created() {
    const response = await this.fetchContentForm();
    if (response.status !== 200) {
      this.$swal({
        type: "error",
        title: ":/",
        text: `Houve um problema ao receber as informações.`,
        confirmButtonText: "Ok",
      });
    }
  },

  methods: {
    async sendData() {
      const dataToSend = {
        textFirstView: this.formContent.textFirstView,
        textWarningBalloon: this.formContent.textWarningBalloon,
        textSecondView: this.formContent.textSecondView,
        textForNonCustom: this.formContent.textForNonCustom,
        textLinkWhatsapp: this.formContent.textLinkWhatsapp,
        textlinkSendFiles: this.formContent.textlinkSendFiles,
        textForCustom: this.formContent.textForCustom,
        textForNotFound: this.formContent.textForNotFound,
      };
      const data = removeEmptySpaces(dataToSend);
      try {
        const response = await this.patchContentForm(data);
        if (response.status === 200) {
          this.$swal({
            type: "success",
            title: ":)",
            text: "Alterações realizadas com sucesso",
            confirmButtonText: "Ok",
          });
        } else {
          this.$swal({
            type: "error",
            title: ":/",
            text: `Ocorreu um erro no envio`,
            confirmButtonText: "Ok",
          });
        }
      } catch (error) {
        console.error(error);
      }
    },
    submitForm() {
      this.sendData();
    },
    fetchContentForm() {
      return this.$store.dispatch("form/fetchContentForm");
    },
    patchContentForm(data) {
      return this.$store.dispatch("form/patchContentForm", data);
    },
  },
  computed: {
    formContent() {
      return this.$store.state.form.formContent;
    },
    isButtonDisabled() {
      const properties = [
        "textFirstView",
        "textWarningBalloon",
        "textSecondView",
        "textForNonCustom",
        "textForCustom",
        "textForNotFound",
        "textLinkWhatsapp",
        "textlinkSendFiles",
      ];
      return properties.some(
        (prop) => removeEmptySpaces(this.formContent[prop]) === ""
      );
    },
  },
  components: {
    Toolbar,
    Headerbar,
    VueEditor,
  },
};
</script>
<style>
.warning {
  font-weight: 500;
  color: red;
  font-size: 16px;
}
.warning-format {
  font-weight: bold;
  color: #3c4c7c;
}
.important {
  color: red;
}
.ql-editor {
  background-color: #ffffff;
}
.editor .ql-editor {
  min-height: 0;
}
label {
  margin: 10px 0;
}
.content-step {
  background: #f3f3f3;
  padding: 30px;
  border-radius: 30px;
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Budgets/EditForm.vue